module.exports = __webpack_public_path__ + "static/media/29ADMSPC38.df5af5a8.jpg";